export const phoneNumberMask = "###-###-####";
export const stateMask = "@@";
export const phoneRegex = /^(?!0{10})\d{10}$/;
export const einMask = "##-#######";
export const oneTimeCodeRegex = /[0-9]{6}/;
export const ssnRegex = /^(?!0{9})[0-9]{9}$/;
export const zipCodeRegex = /^[0-9]{5}$/;
export const stateCodeRegex = /^[a-zA-Z]{2}$/;
export const allStatesRegex = /^(AL|AK|AZ|AR|CA|CO|CT|DC|DE|FL|GA|HI|ID|IL|IN|IA|KS|KY|LA|ME|MD|MA|MI|MN|MS|MO|MT|NE|NV|NH|NJ|NM|NY|NC|ND|OH|OK|OR|PA|RI|SC|SD|TN|TX|UT|VT|VA|WA|WV|WI|WY)$/i;
export const emailRegex = /^[\w\.\+\-]+@[a-zA-Z\d\-]+\.[a-zA-Z]{2,}$/;
export const dotIdRegex = /^(?=.*[1-9])\d{1,10}$/;
export const otpRegex = /^(?=.*[1-9])\d{1,6}$/;

// Constants
export const pollingInterval = 7000;

export const phoneNumberErrorMsg = "Please enter a valid 10-digit phone number";
export const einErrorMsg = "Please enter a valid EIN";
export const zipErrorMsg = "Please enter a valid 5-digit ZIP code";
export const addressErrorMsg = "Please enter a valid address";
export const cityErrorMsg = "Please enter a valid city";
export const stateErrorMsg = "Please enter a valid state";
export const firstNameErrorMsg = "Please enter your first name";
export const lastNameErrorMsg = "Please enter your last name";
export const ssnErrorMsg = "Please enter a valid 9-digit SSN";
export const validSsnErrorMsg = "Please enter a valid 9-digit SSN";
export const validDOTErrorMsg = "Please enter a valid DOT";
export const validEmailErrorMsg = "Please enter a valid email";
export const businessStructureErrorMsg = "Please select a Corporation Type";
export const validOtpErrorMsg = "Please enter the 6-digit OTP";

export const addressMissingMsg = "A valid address is required in order to continue";
export const cityMissingMsg = "City is required in order to continue";
export const einMissingMsg = "Your tax id is required in order to continue";
export const phoneNumberMissingMsg = "A valid phone number is required in order to continue";
export const stateMissingMsg = "State is required in order to continue";
export const zipMissingMsg = "Zip is required in order to continue";

export const accountOwnerNameErrorMsg = "Please enter the name on account";
export const wireRoutingNumberErrorMsg = "Please enter a valid 9 digit wire routing number";

export const US_STATES = new Set([ "AL","AK","AZ","AR","CA","CO","CT","DC","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY" ]);
export const CUSTOM_AUTH_NAME = "custom-auth";

/* Helpline */
export const congratulationsMsg = "Congratulations";
export const bobtailFactoringStr = "Bobtail Factoring";
export const businessDetailsStr = "Business Details";
export const verifyOnwersStr = "Verify Owners";
export const verifyEmailStr = "Verify your email";
export const addAnOwnerStr = "Add an owner";
export const supportStr = "Support";
export const helpLineNumber = "410-204-2084";
export const supportEmail = "support@bobtail.com";
export const completeFieldsStr = "Complete all the fields to continue.";
export const reviewInformationStr = "Review the information below.";

export const applicationDeniedStr = "Application is denied";

export const somethingWentWrongTitle = "Something went wrong.";
export const somethingWentWrongMsg = "Something is not working, check your connection and try again. If the problem persists, please call 410-204-2084..";
export const somethingIsNotWorkingMsg = "Something went wrong. Please share a screenshot with support to help resolve the issue.";
export const linkVerifyEmailMsg = "We have sent you a link to verify your account. Please use it and sign in.";
export const authenticateErrorMsg = "We can't authenticate you right now";
export const userNotFoundErrorMsg = "Client details could not be fetched. Please call at 410-204-2084 for support";
export const nextPageNavigationErrorMsg = "Could not navigate to next page";
export const businessIdNotFoundErrorMsg = "Business Id not found";
export const documentCompletionErrorMsg = "Document completion exception";

export const reviewAndEditOwnersMsg = "Review and edit the listed owners of your organization.";
export const seeOwnerDetailsMsg = "Click to see owner details and start the verification process.";
export const verifyOneOwnerMsg = "You must verify the identity of at least one owner to continue with your application.";
export const saveOwnerMsg = "Click to save owner details, and be able to send ID verification link. Link expires in 24 hours.";
export const ownerAlreadySavedMsg = "We will send an ID verification link to the phone number of this owner. Link expires in 24 hours.";
export const confirmDeleteOwnerMsg = "Are you sure you want to delete this owner?";

export const applicationInReviewMsg = "We're on it! Someone from our team will be reaching out within 48 hours to share a detailed update.";
export const applicationIsDeniedMsg = "Unfortunately, we can not accept your application right now. You can reach out to our Support for further details.";
export const applicationAcceptedMsg = 'Your application was approved.';
export const applicationAcceptedInstructionsNewBusinessMsg = 'To begin, upload your certificate of insurance and select a primary bank account.';
export const applicationAcceptedInstructionsImportedBusinessMsg = 'To start, upload your certificate of insurance. You can change your primary bank account after loggin in.';
export const confirmBusinessDetailsMsg = "Confirm Business Details";
export const verifyOwnersIdentityMsg = "Verify Owner/s Identity";
export const identityVerificationPendingMsg = "We will send an ID verification link to the phone number of this owner. Link expires in 24 hours.";
export const identityVerificationInProgressMsg = "An ID verification link has been sent to the phone number of this owner.";
export const identityVerificationPassedMsg = "The owner has successfully passed the identity verification check.";
export const identityVerificationExpiredMsg = "The ID verification link sent to this owner has expired.";
export const identityVerificationResubmitMsg = "The ID verification is not accurate. Please, use the same link and resubmit the ID verification.";
export const identityVerificationFailedMsg = "The owner has failed the identity verification check.";

export const genericErrorMessage = "Something went wrong, please try again later";

export const COLOR_WHITE = '#ffffff';

export const viewBusinessDetailsFleetCardInfoMsg = "Looks like you already are using Bobtail Zero, review your information and continue.";

export const businessViewContinueButtonText = "Continue to verification";

export const DEFAULT_COUNTRY_CODE = 'US';

